module.exports = {
  F: { api: 'f', human: 'Firma', showForSelect: false },
  M: { api: 'm', human: 'Herr', showForSelect: true },
  W: { api: 'w', human: 'Frau', showForSelect: true }
}
